import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoryState} from './story.reducer';
import {Character, Event, Story} from 'gamesis-story-client';
import {selectActiveCharacters, selectCurrentCharacter, selectMyCharacterIds} from '../characters/character.selectors';

export const selectStoryState = createFeatureSelector<StoryState>('story');

export const selectEvents = createSelector(
    selectStoryState,
    (state: StoryState) => state.events.filter(event => event.type !== 'hidden')
);

export const selectEventsReversed = createSelector(
    selectEvents,
    (events: Event[]) => events.reverse()
);

export const selectStory = createSelector(
    selectStoryState,
    (state: StoryState) => [...state.events].reverse().find(event => event.type === 'story') as Story
);

export const selectLoaded = createSelector(
    selectStoryState,
    (state: StoryState) => state.events.length
);

export const selectCount = createSelector(
    selectStoryState,
    (state: StoryState) => state.count
);

export const selectInitialized = createSelector(
    selectStoryState,
    (state: StoryState) => state.initialized
);

export const selectHasMore = createSelector(
    selectCount,
    selectLoaded,
    (count: number, loaded: number) => count > loaded
);

export const selectStoryLoading = createSelector(
    selectStoryState,
    (state: StoryState) => state.loading
);

export const selectEventById = (id: string) => createSelector(
    selectEvents,
    (events: Event[]) => events.find(event => event.id === id)
);

export const selectEventCount = createSelector(
    selectEvents,
    (events) => events.length
);

export const selectActiveStoryCharacters = createSelector(
    selectActiveCharacters,
    selectStory,
    (characters: Character[], story: Story) => characters.filter(character => story && [...story.characters].includes(character.id))
);

export const selectMyStoryCharacters = createSelector(
    selectActiveStoryCharacters,
    selectMyCharacterIds,
    (active: Character[], mine: string[]) => {
        return active
            .filter(character => mine.includes(character.id));
    }
);

export const selectStoryCharacterCandidates = createSelector(
    selectMyStoryCharacters,
    selectCurrentCharacter,
    (characters: Character[], current) => {
        return characters
            .filter(character => character.id !== current?.id);
    }
);

export const selectCharacterActivity = createSelector(
    selectStoryState,
    selectCurrentCharacter,
    (state: StoryState, character) => Object.keys(state.activity ? state.activity : {})
        .filter(key => key !== character.id)
        .reduce((result, key) => {
            result[key] = state.activity[key];
            return result;
        }, {})
);
